<template>
  <div>
    <div v-if="user.uid">
      <Dashboard />
    </div>
    <div v-else>
      <Login />
    </div>
  </div>
</template>
<script>
import Login from "./Login";
import Dashboard from "./Dashboard";
export default {
  name: "Home",
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
    },
  },
  methods: {},
  components: {
    Login,
    Dashboard,
  },
};
</script>
